'use client';
import "../../i18n"
import ContactUs from '../components/contactUs'

export default function BambooPage() {

    return (
        <>
        <main data-bs-theme="dark" className="component relative w-full flex flex-col color-mode items-end dark:bg-dark">
            <div className="pt-[160px] w-full">
                < ContactUs />
            </div>
        </main>
        </>
    );
}

